import { useState, useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function HousingPage() {
  const [activeTab, setActiveTab] = useState('resources');

  // Scroll to top of page when tab changes
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [activeTab]);

  const resources = [
    {
      id: 1,
      title: 'Sherry FitzGerald',
      description: 'Ireland\'s largest estate agency with extensive rental and sales listings across all major cities',
      icon: 'ri-home-4-line',
      url: 'https://www.sherryfitz.ie',
      category: 'Estate Agency',
      featured: true
    },
    {
      id: 2,
      title: 'Daft.ie',
      description: 'Ireland\'s largest property website with thousands of rental and sales listings across the country',
      icon: 'ri-home-line',
      url: 'https://www.daft.ie',
      category: 'Property Portal',
      featured: true
    },
    {
      id: 3,
      title: 'MyHome.ie',
      description: 'Popular property search site with detailed neighborhood information and market insights',
      icon: 'ri-building-line',
      url: 'https://www.myhome.ie',
      category: 'Property Portal',
      featured: true
    },
    {
      id: 4,
      title: 'Rent.ie',
      description: 'Comprehensive rental platform with verified listings and tenant resources',
      icon: 'ri-key-line',
      url: 'https://www.rent.ie',
      category: 'Property Portal'
    },
    {
      id: 5,
      title: 'Savills Ireland',
      description: 'Premium property services for high-end rentals and sales across Ireland',
      icon: 'ri-vip-crown-line',
      url: 'https://www.savills.ie',
      category: 'Estate Agency'
    },
    {
      id: 6,
      title: 'Knight Frank Ireland',
      description: 'International property consultancy with luxury Irish properties',
      icon: 'ri-building-2-line',
      url: 'https://www.knightfrank.ie',
      category: 'Estate Agency'
    },
    {
      id: 7,
      title: 'Residential Tenancies Board (RTB)',
      description: 'Official government body regulating the rental sector and protecting tenant rights',
      icon: 'ri-shield-check-line',
      url: 'https://www.rtb.ie',
      category: 'Government Resource'
    },
    {
      id: 8,
      title: 'Threshold',
      description: 'National housing charity providing free advice and support to tenants',
      icon: 'ri-customer-service-line',
      url: 'https://www.threshold.ie',
      category: 'Tenant Support'
    },
    {
      id: 9,
      title: 'Citizens Information',
      description: 'Comprehensive guide to renting rights, deposits, and tenancy agreements',
      icon: 'ri-information-line',
      url: 'https://www.citizensinformation.ie',
      category: 'Information'
    }
  ];

  const universities = [
    {
      id: 1,
      name: 'Trinity College Dublin',
      location: 'Dublin 2',
      type: 'University',
      icon: 'ri-building-4-line',
      url: 'https://www.tcd.ie',
      housingUrl: 'https://www.tcd.ie/accommodation/'
    },
    {
      id: 2,
      name: 'University College Dublin (UCD)',
      location: 'Dublin 4',
      type: 'University',
      icon: 'ri-building-4-line',
      url: 'https://www.ucd.ie',
      housingUrl: 'https://www.ucd.ie/residences/'
    },
    {
      id: 3,
      name: 'University College Cork (UCC)',
      location: 'Cork',
      type: 'University',
      icon: 'ri-building-4-line',
      url: 'https://www.ucc.ie',
      housingUrl: 'https://www.ucc.ie/en/accommodation/'
    },
    {
      id: 4,
      name: 'University of Galway',
      location: 'Galway',
      type: 'University',
      icon: 'ri-building-4-line',
      url: 'https://www.universityofgalway.ie',
      housingUrl: 'https://www.universityofgalway.ie/accommodation/'
    },
    {
      id: 5,
      name: 'Dublin City University (DCU)',
      location: 'Dublin 9',
      type: 'University',
      icon: 'ri-building-4-line',
      url: 'https://www.dcu.ie',
      housingUrl: 'https://www.dcu.ie/students/accommodation'
    },
    {
      id: 6,
      name: 'University of Limerick (UL)',
      location: 'Limerick',
      type: 'University',
      icon: 'ri-building-4-line',
      url: 'https://www.ul.ie',
      housingUrl: 'https://www.ul.ie/campus-life/accommodation'
    },
    {
      id: 7,
      name: 'Maynooth University',
      location: 'Kildare',
      type: 'University',
      icon: 'ri-building-4-line',
      url: 'https://www.maynoothuniversity.ie',
      housingUrl: 'https://www.maynoothuniversity.ie/accommodation'
    },
    {
      id: 8,
      name: 'Technological University Dublin (TU Dublin)',
      location: 'Dublin',
      type: 'Technological University',
      icon: 'ri-building-3-line',
      url: 'https://www.tudublin.ie',
      housingUrl: 'https://www.tudublin.ie/study/student-services/accommodation/'
    },
    {
      id: 9,
      name: 'Munster Technological University (MTU)',
      location: 'Cork & Kerry',
      type: 'Technological University',
      icon: 'ri-building-3-line',
      url: 'https://www.mtu.ie',
      housingUrl: 'https://www.mtu.ie/student-life/accommodation/'
    },
    {
      id: 10,
      name: 'Atlantic Technological University (ATU)',
      location: 'Galway, Mayo, Sligo, Donegal',
      type: 'Technological University',
      icon: 'ri-building-3-line',
      url: 'https://www.atu.ie',
      housingUrl: 'https://www.atu.ie/student-life/accommodation'
    },
    {
      id: 11,
      name: 'South East Technological University (SETU)',
      location: 'Waterford & Carlow',
      type: 'Technological University',
      icon: 'ri-building-3-line',
      url: 'https://www.setu.ie',
      housingUrl: 'https://www.setu.ie/student-life/accommodation'
    },
    {
      id: 12,
      name: 'Technological University of the Shannon (TUS)',
      location: 'Limerick & Athlone',
      type: 'Technological University',
      icon: 'ri-building-3-line',
      url: 'https://www.tus.ie',
      housingUrl: 'https://www.tus.ie/student-life/accommodation/'
    },
    {
      id: 13,
      name: 'Royal College of Surgeons in Ireland (RCSI)',
      location: 'Dublin 2',
      type: 'Medical College',
      icon: 'ri-hospital-line',
      url: 'https://www.rcsi.com',
      housingUrl: 'https://www.rcsi.com/dublin/student-life/accommodation'
    },
    {
      id: 14,
      name: 'National College of Art and Design (NCAD)',
      location: 'Dublin 8',
      type: 'Art College',
      icon: 'ri-palette-line',
      url: 'https://www.ncad.ie',
      housingUrl: 'https://www.ncad.ie/student-life/accommodation/'
    },
    {
      id: 15,
      name: 'Griffith College',
      location: 'Dublin, Cork, Limerick',
      type: 'Private College',
      icon: 'ri-school-line',
      url: 'https://www.griffith.ie',
      housingUrl: 'https://www.griffith.ie/student-life/accommodation'
    }
  ];

  const tips = [
    {
      id: 1,
      title: 'Start Your Search Early',
      description: 'The Irish rental market is competitive, especially in Dublin. Begin searching 4-6 weeks before your move date.',
      icon: 'ri-calendar-check-line',
      color: 'bg-blue-100 text-blue-600'
    },
    {
      id: 2,
      title: 'Understand Deposit Rules',
      description: 'Landlords typically require one month\'s rent as a deposit. This must be registered with the RTB within 30 days.',
      icon: 'ri-money-euro-circle-line',
      color: 'bg-emerald-100 text-emerald-600'
    },
    {
      id: 3,
      title: 'Get References Ready',
      description: 'Prepare employment references, previous landlord references, and proof of income before viewing properties.',
      icon: 'ri-file-text-line',
      color: 'bg-amber-100 text-amber-600'
    },
    {
      id: 4,
      title: 'Know Your Rights',
      description: 'Familiarize yourself with Irish tenancy laws. The RTB website has comprehensive guides for tenants.',
      icon: 'ri-scales-line',
      color: 'bg-purple-100 text-purple-600'
    },
    {
      id: 5,
      title: 'Beware of Scams',
      description: 'Never send money before viewing a property. Always verify the landlord\'s identity and property ownership.',
      icon: 'ri-alert-line',
      color: 'bg-red-100 text-red-600'
    },
    {
      id: 6,
      title: 'Consider Commute Times',
      description: 'Dublin traffic can be heavy. Research public transport options and commute times before committing.',
      icon: 'ri-bus-line',
      color: 'bg-indigo-100 text-indigo-600'
    },
    {
      id: 7,
      title: 'Budget for Utilities',
      description: 'Most rentals don\'t include utilities. Budget an extra €150-250/month for electricity, gas, internet, and TV license.',
      icon: 'ri-lightbulb-line',
      color: 'bg-teal-100 text-teal-600'
    },
    {
      id: 8,
      title: 'Join Facebook Groups',
      description: 'Many landlords post on Facebook groups like "Rent Dublin" or "Cork Rentals" before listing on major sites.',
      icon: 'ri-facebook-circle-line',
      color: 'bg-pink-100 text-pink-600'
    }
  ];

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />

      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-[#0A381F] to-[#0D4A28] text-white py-20">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-6">
              <i className="ri-home-heart-line text-4xl"></i>
            </div>
            <h1 className="text-5xl font-bold mb-4">Housing in Ireland</h1>
            <p className="text-xl text-white/90 max-w-2xl mx-auto">
              Find your perfect home with trusted resources, university housing, and expert guides
            </p>
            
            {/* Navigation Tabs */}
            <div className="flex items-center justify-center gap-2 mt-8 flex-wrap">
              <button
                onClick={() => setActiveTab('resources')}
                className={`px-6 py-3 rounded-full text-sm font-semibold transition-all whitespace-nowrap ${
                  activeTab === 'resources'
                    ? 'bg-white text-[#0A381F] shadow-md'
                    : 'bg-[#D4AF37] text-white hover:bg-[#C19B2F]'
                }`}
              >
                <i className="ri-home-line mr-2"></i>
                Property Resources
              </button>
              <button
                onClick={() => setActiveTab('universities')}
                className={`px-6 py-3 rounded-full text-sm font-semibold transition-all whitespace-nowrap ${
                  activeTab === 'universities'
                    ? 'bg-white text-[#0A381F] shadow-md'
                    : 'bg-[#D4AF37] text-white hover:bg-[#C19B2F]'
                }`}
              >
                <i className="ri-graduation-cap-line mr-2"></i>
                University Housing
              </button>
              <button
                onClick={() => setActiveTab('tips')}
                className={`px-6 py-3 rounded-full text-sm font-semibold transition-all whitespace-nowrap ${
                  activeTab === 'tips'
                    ? 'bg-white text-[#0A381F] shadow-md'
                    : 'bg-[#D4AF37] text-white hover:bg-[#C19B2F]'
                }`}
              >
                <i className="ri-lightbulb-line mr-2"></i>
                Expert Tips
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Planning a Scouting Trip Section */}
      <div className="bg-gradient-to-br from-[#D4AF37] to-[#C19B2F] py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
              {/* Left Side - Content */}
              <div className="p-8 lg:p-12 flex flex-col justify-center">
                <div className="w-16 h-16 bg-[#0A381F]/10 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-plane-line text-3xl text-[#0A381F]"></i>
                </div>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">
                  Planning a Scouting Trip to Ireland?
                </h2>
                <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                  Before committing to a long-term rental, many Americans find it helpful to visit Ireland first. Explore neighborhoods, meet potential employers, and get a feel for daily life.
                </p>
                <div className="space-y-4 mb-8">
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-check-line text-emerald-600 text-sm"></i>
                    </div>
                    <p className="text-gray-700">
                      <strong className="text-gray-900">Explore neighborhoods</strong> in Dublin, Cork, Galway, and other cities
                    </p>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-check-line text-emerald-600 text-sm"></i>
                    </div>
                    <p className="text-gray-700">
                      <strong className="text-gray-900">Attend job interviews</strong> and meet with potential employers in person
                    </p>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-check-line text-emerald-600 text-sm"></i>
                    </div>
                    <p className="text-gray-700">
                      <strong className="text-gray-900">View properties</strong> and understand the local rental market firsthand
                    </p>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-check-line text-emerald-600 text-sm"></i>
                    </div>
                    <p className="text-gray-700">
                      <strong className="text-gray-900">Experience Irish culture</strong> and confirm it's the right fit for you
                    </p>
                  </div>
                </div>
                <a
                  href="https://www.stay22.com/allez/irelandbound?aid=irelandbound"
                  target="_blank"
                  rel="noopener noreferrer sponsored"
                  className="inline-flex items-center justify-center px-8 py-4 bg-[#0A381F] text-white rounded-full font-semibold text-lg hover:bg-[#0D4A28] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-hotel-line mr-3 text-xl"></i>
                  Find Accommodations for Your Visit
                  <i className="ri-arrow-right-line ml-3 text-xl"></i>
                </a>
                <p className="text-sm text-gray-500 mt-4">
                  <i className="ri-information-line mr-1"></i>
                  Book hotels, apartments, and vacation rentals across Ireland
                </p>
              </div>

              {/* Right Side - Image */}
              <div className="relative h-64 lg:h-auto">
                <img
                  src="https://public.readdy.ai/ai/img_res/8b1e3e5706ed4b5243f580e50aa96c35.jpg"
                  alt="Exploring Dublin neighborhoods during scouting trip"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent lg:bg-gradient-to-r lg:from-white lg:via-white/50 lg:to-transparent"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content - Add ref here for scroll target */}
      <div className="flex-1 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Resources Tab */}
          {activeTab === 'resources' && (
            <div>
              <div className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-2">Property Search Resources</h2>
                <p className="text-gray-600">Trusted websites and estate agencies for finding accommodation in Ireland</p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {resources.map((resource) => (
                  <a
                    key={resource.id}
                    href={resource.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`bg-white rounded-lg border-2 p-6 hover:shadow-lg transition-all cursor-pointer ${
                      resource.featured 
                        ? 'border-[#D4AF37] bg-gradient-to-br from-[#D4AF37]/5 to-transparent' 
                        : 'border-gray-200 hover:border-[#0A381F]'
                    }`}
                  >
                    {resource.featured && (
                      <div className="mb-3">
                        <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-semibold bg-[#D4AF37] text-white">
                          <i className="ri-star-fill mr-1"></i>
                          Featured Partner
                        </span>
                      </div>
                    )}
                    <div className="w-12 h-12 bg-[#0A381F]/10 rounded-lg flex items-center justify-center mb-4">
                      <i className={`${resource.icon} text-2xl text-[#0A381F]`}></i>
                    </div>
                    <div className="mb-3">
                      <span className="text-xs font-medium text-[#D4AF37] uppercase tracking-wide">{resource.category}</span>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">{resource.title}</h3>
                    <p className="text-gray-600 text-sm mb-4">{resource.description}</p>
                    <div className="flex items-center text-[#0A381F] text-sm font-medium">
                      <span>Visit Website</span>
                      <i className="ri-arrow-right-line ml-2"></i>
                    </div>
                  </a>
                ))}
              </div>

              {/* CTA for Sherry FitzGerald */}
              <div className="mt-12 bg-gradient-to-br from-[#0A381F] to-[#0D4A28] rounded-2xl p-8 text-white">
                <div className="flex items-start gap-6">
                  <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-home-smile-line text-3xl"></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold mb-3">Looking for Professional Property Services?</h3>
                    <p className="text-white/90 mb-6 leading-relaxed">
                      Sherry FitzGerald is Ireland's largest and most trusted estate agency, with over 90 offices nationwide. They specialize in helping international clients find rentals and properties for sale across Dublin, Cork, Galway, and beyond.
                    </p>
                    <a
                      href="https://www.sherryfitz.ie"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center px-6 py-3 bg-white text-[#0A381F] rounded-full font-semibold hover:bg-gray-100 transition-all whitespace-nowrap cursor-pointer"
                    >
                      Browse Sherry FitzGerald Properties
                      <i className="ri-arrow-right-line ml-2"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* University Housing Tab - NEW */}
          {activeTab === 'universities' && (
            <div>
              <div className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-2">University & College Housing</h2>
                <p className="text-gray-600">Student accommodation options at Ireland's top universities and colleges</p>
              </div>
              
              {/* Info Banner */}
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-8">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-information-line text-xl text-blue-600"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">Student Housing in Ireland</h3>
                    <p className="text-gray-700 text-sm leading-relaxed">
                      Most Irish universities offer on-campus accommodation for international students. Apply early as spaces fill quickly! Many universities also provide assistance finding off-campus housing through their accommodation offices.
                    </p>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {universities.map((uni) => (
                  <div key={uni.id} className="bg-white rounded-lg border border-gray-200 p-6 hover:shadow-lg transition-shadow">
                    <div className="w-12 h-12 bg-[#0A381F]/10 rounded-lg flex items-center justify-center mb-4">
                      <i className={`${uni.icon} text-2xl text-[#0A381F]`}></i>
                    </div>
                    <div className="mb-3">
                      <span className="text-xs font-medium text-[#D4AF37] uppercase tracking-wide">{uni.type}</span>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">{uni.name}</h3>
                    <div className="flex items-center text-gray-600 text-sm mb-4">
                      <i className="ri-map-pin-line mr-1"></i>
                      <span>{uni.location}</span>
                    </div>
                    <div className="flex flex-col gap-2">
                      <a
                        href={uni.housingUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center justify-center px-4 py-2 bg-[#0A381F] text-white rounded-lg text-sm font-medium hover:bg-[#0D4A28] transition-all whitespace-nowrap cursor-pointer"
                      >
                        <i className="ri-home-4-line mr-2"></i>
                        View Housing Options
                      </a>
                      <a
                        href={uni.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center justify-center px-4 py-2 border border-gray-300 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50 transition-all whitespace-nowrap cursor-pointer"
                      >
                        <i className="ri-external-link-line mr-2"></i>
                        Visit Website
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Tips Tab */}
          {activeTab === 'tips' && (
            <div>
              <div className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-2">Housing Tips for Newcomers</h2>
                <p className="text-gray-600">Expert advice to help you navigate the Irish rental market</p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {tips.map((tip) => (
                  <div key={tip.id} className="bg-white rounded-lg border border-gray-200 p-6 hover:shadow-md transition-shadow">
                    <div className="flex items-start gap-4">
                      <div className={`w-12 h-12 ${tip.color} rounded-lg flex items-center justify-center flex-shrink-0`}>
                        <i className={`${tip.icon} text-2xl`}></i>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-lg font-semibold text-gray-900 mb-2">{tip.title}</h3>
                        <p className="text-gray-600 text-sm leading-relaxed">{tip.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

        </div>
      </div>

      <Footer />
    </div>
  );
}